import { useCallback, useEffect, useState } from 'react';
export var useElementPosition = function useElementPosition(element) {
  var getElementPosition = useCallback(function () {
    var pos = (element == null ? void 0 : element.getBoundingClientRect()) || {
      width: 0,
      left: 0
    };
    return {
      width: pos.width,
      left: pos.left
    };
  }, [element]);

  var _useState = useState(getElementPosition()),
      position = _useState[0],
      setPosition = _useState[1];

  var handleWindowResize = useCallback(function () {
    setPosition(getElementPosition());
  }, [setPosition, getElementPosition]);
  useEffect(function () {
    window.addEventListener('resize', handleWindowResize);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [handleWindowResize]);
  useEffect(function () {
    setPosition(getElementPosition());
  }, [element, setPosition, getElementPosition]);
  return position;
};